import type { ChronumLoad } from '@shared/api';
import {
  formatElapsed,
  formatTime,
  loadProgressText,
  periodLabelLower,
  typo,
} from '@entities/chronum';
import type { ChronumRefresh } from '../useChronumRefresh';
import { Bar, Progress } from './styles';

/** «Её начала загрузка по расписанию», «Её начал(а) Мария Экономова». */
export function startedBy(load: ChronumLoad): string {
  if (load.origin === 'schedule') return 'Её начала загрузка по расписанию';
  return `Её начал(а) ${load.started_by_name?.trim() || 'коллега'}`;
}

/** Ход загрузки: месяц, кто начал, сколько ручек готово и сколько идёт. */
export function LoadProgress({ refresh, period }: { refresh: ChronumRefresh; period: string }) {
  const load = refresh.load;
  const month = periodLabelLower(refresh.runningPeriod ?? period);
  const pct = load ? (load.steps_done / Math.max(1, load.steps_total)) * 100 : 0;
  return (
    <Progress>
      <div className="head">
        <span>
          {load
            ? refresh.attached
              ? `Идёт загрузка данных Хронума за ${month} — готово ${loadProgressText(load)}.`
              : `Загружаю данные Хронума за ${month} — готово ${loadProgressText(load)}.`
            : `Начинаю загрузку данных Хронума за ${month}…`}
        </span>
        <span className="sec" aria-hidden="true">
          {formatElapsed(refresh.elapsed)}
        </span>
      </div>
      <Bar $pct={pct} aria-hidden="true" />
      <p className="note">
        {load && refresh.attached
          ? typo(
              `${startedBy(load)} в ${formatTime(load.started_at)} — вторая за этот месяц не начинается. Итог появится здесь сам.`,
            )
          : typo(
              'Загрузка идёт на сервере: вкладку можно закрыть — она не оборвётся, а итог будет в «Истории загрузок».',
            )}
      </p>
    </Progress>
  );
}
